import React from "react";

const ReadyContext = React.createContext(false);

export default ReadyContext;